import PropTypes from 'prop-types';

/**
 * PropTypes for user permissions (owner/editor) within a collection
 */
export const permissionUserPropType = PropTypes.shape({
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
});

/**
 * PropTypes for collection permissions structure
 */
export const permissionsPropType = PropTypes.shape({
  owners: PropTypes.arrayOf(permissionUserPropType),
  editors: PropTypes.arrayOf(permissionUserPropType)
});

/**
 * PropTypes for account object with user data
 */
export const accountPropType = PropTypes.shape({
  data: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })
});

/**
 * PropTypes for a collection object
 */
export const collectionPropType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  slug: PropTypes.string,
  categories: PropTypes.array,
  fetchable_list_items: PropTypes.array,
  permissions: permissionsPropType
});

/**
 * PropTypes for a category object
 */
export const categoryPropType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  title: PropTypes.string,
  slug: PropTypes.string
});
